<template>
  <div class="container">
    <v-card>
      <v-toolbar dark color="primary">
        <v-toolbar-title>Gestión de Canchas</v-toolbar-title>
      </v-toolbar>
      <v-data-table
        v-if="listaCanchas.length"
        :headers="headers"
        :items="this.listaCanchas"
        class="elevation-1"
        locale="es-ar"
        item-key="idCancha"
        :items-per-page="10"
        ref="myTable"
        :disable-sort="true"
        :footer-props="{
          itemsPerPageText: 'Filas por página',
        }"
      >
        <template v-slot:item.activa="{ item }">
          <v-simple-checkbox v-model="item.activa" disabled></v-simple-checkbox>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                medium
                color="purple"
                class="mr-3"
                v-on="on"
                v-bind="attrs"
                @click.stop="editarCancha(item)"
                >mdi-pencil</v-icon
              >
            </template>
            <span>Editar Canchas</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                medium
                v-on="on"
                color="red"
                v-bind="attrs"
                class="mr-3"
                @click="borrarCancha(item)"
                >mdi-delete</v-icon
              >
            </template>
            <span>Eliminar Cancha</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                medium
                :color="item.activa ? 'warning' : 'green'"
                class="mr-3"
                v-on="on"
                v-bind="attrs"
                @click.stop="activarDesactivarCancha(item)"
                >{{ item.activa ? "mdi-thumb-down" : "mdi-thumb-up" }}</v-icon
              >
            </template>
            <span>{{ item.activa ? "Desactivar" : "Activar" }} Cancha</span>
          </v-tooltip>
        </template>
      </v-data-table>
      <v-alert class="mt-4" color="purple" dark outlined v-else>
        No hay Canchas configuradas para el complejo.
      </v-alert>
      <v-card-actions>
        <v-btn dark color="#24232d" @click="salir">
          <v-icon left>mdi-arrow-left</v-icon>
          Volver
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="success" @click.stop="nuevaCancha">Nueva Cancha</v-btn>
      </v-card-actions>
      <NuevaCancha
        :visible="showNuevaCancha"
        @close="cierraNuevaCancha()"
        @canchaRegistrada="canchaRegistrada()"
      ></NuevaCancha>
      <EditarCancha
        :visible="showEditarCancha"
        :idCancha="editedItem.idCancha"
        @close="cierraEditarCancha()"
        @canchaModificada="canchaModificada()"
      ></EditarCancha>
    </v-card>
  </div>
</template>
<style scoped>
::v-deep .v-data-table__empty-wrapper {
  display: none;
}
.container {
  margin: auto;
}
</style>
<script>
import axios from "@/axios-auth";
import router from "@/router";
import NuevaCancha from "@/components/Gestion/Canchas/NuevaCancha";
import EditarCancha from "@/components/Gestion/Canchas/EditarCancha";
import { showAlert } from "@/utils/toast";
export default {
  data: (vm) => ({
    listaCanchas: [],
    headers: [
      { text: "Nombre", value: "nombre" },
      { text: "Tipo de Cancha", value: "tipoCancha" },
      { text: "Tipo de Piso", value: "tipoPiso" },
      { text: "Tipo de Paredes", value: "tipoParedes" },
      { text: "Activa", value: "activa" },
      { text: "Observaciones", value: "observaciones" },
      { text: "Acciones", value: "actions" },
    ],
    showNuevaCancha: false,
    showEditarCancha: false,
    editedItem: {},
    editedIndex: -1,
  }),
  methods: {
    salir() {
      router.push({ path: "/Home" });
    },

    async activarDesactivarCancha(item) {
      try {
        await axios.get("/Cancha/ActivarDesactivarCancha", {
          params: {
            idCancha: item.idCancha,
            estado: !item.activa,
          },
        });
        this.showAlert({
          icon: "success",
          title: `Cancha ${
            item.activa ? "desactivada" : "activada"
          } exitosamente.`,
          vm: this,
          timer: 2500,
        });
        setTimeout(() => {
          this.buscarCanchas();
        }, 500);
      } catch (error) {
        console.log(error);
        this.showAlert({
          icon: "warning",
          title:
            "No se pudo desactivar la cancha. Intente nuevamente más tarde",
          vm: this,
          timer: 2000,
        });
      }
    },

    showAlert(alertInfo) {
      showAlert(alertInfo);
    },

    borrarCancha(item) {
      this.$swal({
        title: "Borrar Cancha",
        text: "¿Desea borrar la cancha?",
        icon: "success",
        background: "#ececec",
        showClass: {
          popup: "animate__animated animate__fadeInDown",
        },
        hideClass: {
          popup: "animate__animated animate__fadeOutUp",
        },
        showCancelButton: true,
        confirmButtonText: "Si",
        cancelButtonText: "No",
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          //this.$swal('Turno g', 'You successfully deleted this file', 'success')

          const idCancha = item.idCancha;
          let self = this;
          axios
            .get("/Cancha/BorrarCancha?", {
              params: {
                idCancha: idCancha,
              },
            })
            .then((response) => {
              if (response.data == "error") {
                self.showAlert({
                  icon: "warning",
                  title: "La cancha tiene transacciones. No se puede borrar.",
                  vm: self,
                  timer: 2000,
                });
              } else {
                self.showAlert({
                  icon: "success",
                  title: "Cancha borrada exitosamente",
                  vm: self,
                  timer: 2000,
                });
                setTimeout(self.buscarCanchas(), 1700);
              }
            })
            .catch((error) => {
              self.showAlert({
                icon: "warning",
                title: "La cancha no pudo ser borrada",
                vm: this,
              });
            });
        } else {
          //this.$swal('Cancelled', 'Your file is still intact', 'info')
        }
      });
    },
    cierraNuevaCancha() {
      this.showNuevaCancha = false;
    },
    cierraEditarCancha() {
      this.showEditarCancha = false;
    },
    canchaRegistrada() {
      this.showNuevaCancha = false;
      this.buscarCanchas();
    },
    canchaModificada() {
      this.showEditarCancha = false;
      this.buscarCanchas();
    },
    nuevaCancha() {
      this.showNuevaCancha = true;
    },
    editarCancha(item) {
      this.editedIndex = this.listaCanchas.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.showEditarCancha = true;
    },
    buscarCanchas() {
      const filtrosData = {
        idInstitucion: this.$store.state.usuario.institucion.idInstitucion,
      };

      let self = this;
      axios
        .get("/Cancha/GetCanchas?", {
          params: {
            idInstitucion: filtrosData.idInstitucion,
          },
        })
        .then(function (response) {
          if (response.data != null && response.data != "")
            self.listaCanchas = response.data;
          else self.listaCanchas = [];
        })
        .catch(function (error) {});
    },
  },
  created() {
    this.buscarCanchas();
  },
  components: {
    NuevaCancha,
    EditarCancha,
  },
};
</script>
